import {AbstractConditionDescriptionComponent} from "../AbstractConditionDescriptionComponent";

export class ConditionOriginalEquityExceeds extends AbstractConditionDescriptionComponent {

    static instance = () => AbstractConditionDescriptionComponent.instance(ConditionOriginalEquityExceeds, require('./ConditionOriginalEquityExceeds.html'))
}